<div class="scoring">
  <div class="scoring__item" [ngClass]="{'disabled': enableCheckbox}">{{ icdCode?.code }} <br> <span class="scoring__item--hcc">{{getHccId()}}</span></div>
  <div class="scoring__item" [ngClass]="{'disabled': enableCheckbox}">{{ icdCode?.text }}</div>
  <div class="scoring__item" [ngClass]="{'disabled': enableCheckbox}">{{ icdCode?.confidenceScore | slice:0:7 }}</div>
  <div class="scoring__item"><input #checkboxes [checked]="checkboxStatus" [disabled]="enableCheckbox" type="checkbox" class="input-checkbox input-checkbox--{{idx}}"
      id="icd-checkbox-{{idx}}-{{index}}" [ngClass]="{'disabled': enableCheckbox}" (change)="onCheckboxChange($event)" /></div>
</div>
